import { render } from "./file-earmark-text.vue?vue&type=template&id=6d5fa164"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/file-earmark-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d5fa164"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d5fa164', __exports__)) {
    api.reload('6d5fa164', __exports__)
  }
  
  module.hot.accept("./file-earmark-text.vue?vue&type=template&id=6d5fa164", () => {
    api.rerender('6d5fa164', render)
  })

}


export default __exports__